import { createApp } from "vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import ElementPlus from "element-plus";
import Highcharts from "highcharts";
import stockInit from "highcharts/modules/stock";
import FULL_SCREEN from "highcharts/modules/full-screen";
import exportingInit from "highcharts/modules/exporting";
import offlineExporting from "highcharts/modules/offline-exporting";
import Histogram from "highcharts/modules/histogram-bellcurve";
import Bullet from "highcharts/modules/bullet";
import HC_more from "highcharts/highcharts-more";
import Heatmap from "highcharts/modules/heatmap";
import Accessibility from "highcharts/modules/accessibility";
import Boost from "highcharts/modules/boost";
import BoostCanvas from "highcharts/modules/boost-canvas";
import Annotations from "highcharts/modules/annotations";
import { filters } from "./common/filters";
import VueGridLayout from "vue3-grid-layout-next";
import OktaVue from "@okta/okta-vue";
import { oktaAuth } from "@/services/authentification";
import { I18N } from "./i18n";
import * as ElementPlusIconsVue from "@element-plus/icons-vue";

import AppVue from "./App.vue";

FULL_SCREEN(Highcharts);
stockInit(Highcharts);
exportingInit(Highcharts);
offlineExporting(Highcharts);
Histogram(Highcharts);
Bullet(Highcharts);
HC_more(Highcharts);
Annotations(Highcharts);
Heatmap(Highcharts);
Accessibility(Highcharts);
Boost(Highcharts);
BoostCanvas(Highcharts);
const app = createApp(AppVue);
app
  .use(store)
  .use(router)
  .use(ElementPlus, { namespace: "", size: "small", zIndex: 2000 })
  .use(OktaVue, { oktaAuth })
  .use(I18N)
  .use(VueGridLayout)
  .mount("#app");

app.config.globalProperties.$filters = filters;

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component);
}
